// extracted by mini-css-extract-plugin
export default {"logo":"logIn_logo__8gMQR","verticalHr":"logIn_verticalHr__E5qfS","textContainer":"logIn_textContainer__aj90q","footer":"logIn_footer__6ULWG"};